import React, { useState, useEffect } from "react";
import {
  Table,
  TableRow,
  TableBody,
  useTheme,
  Box,
  Typography,
  TableContainer,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import VantageListHead from "../../../../component/ListHead/SignalList";
import {
  Tablecell,
  applySortFilter,
  calculateAndFormatNoAbs,
  getComparator,
} from "../../../../component/Methods";

const UnchangedStocks = ({
  stock,
  tableHeader,
  showUnchangedStocks,
  setShowUnchangedStocks,
}) => {
  const theme = useTheme();
  const [data, setData] = useState([]); 
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("symbol");

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  useEffect(() => {
    if (stock) {
      const formattedData = Object.entries(stock).map(
        ([keyString, valueObject]) => {
          const valueData = valueObject;
          const keyData = JSON.parse(keyString);

          return {
            symbol: keyData.symbol || "",
            currentPosition: valueData.currentPosition || "",
            signal: valueData.signal || "",
          };
        }
      );

      const filteredUsers = applySortFilter(
        formattedData,
        getComparator(order, orderBy)
      );

      setData(filteredUsers);
    }
  }, [order, orderBy, stock]);

  return (
    <Dialog
      open={showUnchangedStocks}
      onClose={() => setShowUnchangedStocks(false)}
      maxWidth="sm" // Changed from md to sm for smaller width
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "8px",
          maxHeight: "80vh",
          width: '480px', // Explicitly set a smaller width
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          color: "#000",
          padding: "16px 24px",
        }}
      >
        <Typography sx={{ fontWeight: 800, fontSize: "1.2rem !important", letterSpacing: 0.5, color: theme.palette.text.primary }}>
          Unchanged Positions 
        </Typography>
        <IconButton
          onClick={() => setShowUnchangedStocks(false)}
          sx={{ color: theme.palette.primary.contrastText }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ padding: "24px" }}>
        
          <Table
            size="small"
            stickyHeader
            aria-label="unchanged stocks table"
            sx={{
              maxHeight: "60vh",
              minHeight: "200px",
            }}
          >
            <VantageListHead
              order={order}
              orderBy={orderBy}
              headLabel={tableHeader}
              noStatus={true}
              customizeFont={13}
              rowCount={data.length}
              onRequestSort={handleRequestSort}
            />
            <TableBody>
              {data?.map((row, index) => (
                <TableRow
                  key={index}
                  sx={{
                    "&:hover": {
                      background: theme.palette.action.hover,
                      cursor: "pointer",
                    },
                  }}
                >
                  <Tablecell
                    align="left"
                    sx={{
                      fontSize: "13px",
                      borderBottom: `1px solid ${theme.palette.divider}`,
                      width: "33.33%",
                      pl: 2, // Add padding left
                      color: theme.palette.text.primary,
                      borderColor: theme.palette.divider,
                    }}
                  >
                    {row?.symbol?.toUpperCase() || ""}
                  </Tablecell>
                  <Tablecell
                    align="right"
                    sx={{
                      fontSize: "13px",
                      borderBottom: `1px solid ${theme.palette.divider}`,
                      width: "33.33%",
                      pr: 2, // Add padding right
                      color: theme.palette.text.primary,
                      borderColor: theme.palette.divider,
                    }}
                  >
                    {row?.currentPosition !== "" && row?.currentPosition !== undefined && row?.currentPosition !== null
                      ? Number(row.currentPosition).toFixed(2)
                      : ""}
                  </Tablecell>
                  <Tablecell
                    align="right"
                    sx={{
                      fontSize: "13px",
                      borderBottom: `1px solid ${theme.palette.divider}`,
                      width: "33.33%",
                      pr: 2, // Add padding right
                      color: theme.palette.text.primary,
                      borderColor: theme.palette.divider,
                    }}
                  >
                    {row?.signal !== undefined && row?.signal !== null && row?.signal !== ""
                      ? Number(row.signal).toFixed(2)
                      : row?.signal === 0
                        ? "0.00"
                        : "0.00"}
                  </Tablecell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
    
      </DialogContent>
    </Dialog>
  );
};

export default UnchangedStocks;